import React from 'react';
import Button from 'antd/lib/button';
import Space from 'antd/lib/space';
import CheckCircleOutlined from '@ant-design/icons/lib/icons/CheckCircleOutlined';
import CloseCircleOutlined from '@ant-design/icons/lib/icons/CloseCircleOutlined';
import ReloadOutlined from '@ant-design/icons/lib/icons/ReloadOutlined';
import { SearchInput } from 'src/components/searchInput/searchInput';
import { ICustomerUtilityBillsQuery } from 'src/domain/customer-utility-bill';
import { CustomerUtilityBillExportButton } from './CustomerUtilityBillExportButton';

interface Props {
    search: string;
    selectedCount: number;
    // True when every selected row is already verified — the bulk button then un-verifies; otherwise it verifies.
    allSelectedVerified: boolean;
    // In-flight flags for the bulk actions, so their buttons can show a spinner and block double-clicks.
    verifying: boolean;
    unverifying: boolean;
    reparsing: boolean;
    // Current list query — the XLSX export reuses its filters/search/sort when "Apply Filters" is chosen.
    query: ICustomerUtilityBillsQuery;
    onSearch: (value: string) => void;
    onVerifySelected: () => void;
    onUnverifySelected: () => void;
    onReparseSelected: () => void;
    onClearSelected: () => void;
}

export const CustomerUtilityBillHeaderActions: React.FC<Props> = ({
    search,
    selectedCount,
    allSelectedVerified,
    verifying,
    unverifying,
    reparsing,
    query,
    onSearch,
    onVerifySelected,
    onUnverifySelected,
    onReparseSelected,
    onClearSelected,
}) => {
    const hasSelection = selectedCount > 0;
    const selectedSuffix = ` (${selectedCount})`;

    return (
        <Space wrap size="small">
            <SearchInput defaultValue={search} onSearch={onSearch} />
            {hasSelection && (
                <>
                    <Button
                        size="large"
                        loading={allSelectedVerified ? unverifying : verifying}
                        icon={allSelectedVerified ? <CloseCircleOutlined /> : <CheckCircleOutlined />}
                        onClick={allSelectedVerified ? onUnverifySelected : onVerifySelected}
                    >
                        {allSelectedVerified ? 'Unverify' : 'Verify'} Selected{selectedSuffix}
                    </Button>
                    <Button size="large" loading={reparsing} icon={<ReloadOutlined />} onClick={onReparseSelected}>
                        Re-parse Selected{selectedSuffix}
                    </Button>
                    <Button size="large" onClick={onClearSelected}>
                        Clear Selected{selectedSuffix}
                    </Button>
                </>
            )}
            <CustomerUtilityBillExportButton query={query} />
        </Space>
    );
};
